// Api.js
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "./Network";

// FOR SUPER ADMIN :  
class Su_Organiation {
  getSuOrgs = (params = {}) => getRequest("organization_su_router", params);
  getSuOrgDetails = (id) => getRequest(`organization_su_router/${id}`);
  createSuOrg = (data) => postRequest("organization_su_router", data);
  updateSuOrgDetails = (id, data) => putRequest(`organization_su_router/${id}`, data);
  deleteSuOrg = (id) => deleteRequest(`organization_su_router/soft/${id}`);
  postUserToOrg = (data) => postRequest("user_org_su_router", data);
  deleteUserFromOrg = (data) => postRequest(`user_org_su_router/soft/delete_user_organization`, data);
  restoreOrgUser = (data) => postRequest("user_org_su_router/undo_user_organization", data);
  hardDeleteOrgUser = (data) => postRequest("user_org_su_router/delete_user_organization", data);
  restoreOrg = (data) => postRequest("organization_su_router/undo_organization", data);
  hardDeleteOrg = (id) => deleteRequest(`organization_su_router/${id}`);
}

class Su_User {
  getSuUsers = (params = {}) => getRequest("user_su_router", params);
  getSuUserDetails = (id) => getRequest(`user_su_router/${id}`);
  createSuUser = (data) => postRequest("user_su_router", data);
  updateSuUserDetails = (id, data) => putRequest(`user_su_router/${id}`, data);
  deleteSuUser = (id) => deleteRequest(`user_su_router/${id}`);
}

class Su_Property {
  getSuProperties = (params = {}) => postRequest("property_su_router/get_all_properties", params);
  getSuPropertyDetails = (id) => getRequest(`property_su_router/${id}`);
  createSuProperty = (data) => postRequest("property_su_router", data);
  updateSuPropertyDetails = (id, data) => putRequest(`property_su_router/${id}`, data);
  deleteSuProperty = (id) => deleteRequest(`property_su_router/soft/${id}`);
  postUserToProperty = (data) => postRequest("user_property_su_router", data);
  deleteUserFromProperty = (data) => postRequest(`user_property_su_router/soft/delete_user_property`, data);
  restorePropertyUser = (data) => postRequest("user_property_su_router/undo_user_property", data);
  hardDeletePropertyUser = (data) => postRequest("user_property_su_router/delete_user_property", data);
  restoreProperty = (data) => postRequest("property_su_router/undo_property", data)
  hardDeleteProperty = (id) => deleteRequest(`property_su_router/${id}`);
}

class Su_Unit {
  getSuUnits = (params = {}) => getRequest("unit_su_router", params);
  getSuUnitDetails = (id) => getRequest(`unit_su_router/${id}`) ;
  createSuUnit = (data) => postRequest("unit_su_router", data);
  updateSuUnitDetails = (id, data) => putRequest(`unit_su_router/${id}`, data);
  deleteSuUnit = (id) => deleteRequest(`unit_su_router/soft/${id}`);
  deleteUserFromUnit = (data) => postRequest(`user_unit_su_router/soft/delete_user_unit`, data);
  restoreUnitUser= (data) => postRequest("user_unit_su_router/undo_user_unit", data);
  hardDeleteUnitUser = (data) => postRequest("user_unit_su_router/delete_user_unit", data);
  restoreUnit = (data) => postRequest("unit_su_router/undo_unit", data);
  hardDeleteUnit = (id) => deleteRequest(`unit_su_router/${id}`);
}

class Assign_user_org {
  assignUserToOrg = (data) => postRequest("user_org_su_router", data);
  removeUserFromOrg = (id) => deleteRequest(`user_org_su_router/${id}`); 
}

class Assign_user_porperty {
  assignUserToProperty = (data) => postRequest("user_property_su_router", data);
  removeUserFromProperty = (id) => deleteRequest(`user_property_su_router/${id}`); 
}

class Assign_user_unit {
  assignUserToUnit = (data) => postRequest("user_unit_su_router", data);
}

class getFiltertedUser {
  getFiltertedUser = (params = {}) => postRequest("user_su_router/get_all_user", params);
}
 
class ShiftNote {
  getShiftNote = (data) => postRequest("shift_note/get_all_shift_notes", data);
  createShiftNote = (data) => postRequest("shift_note", data);
}

class Ticket {
  createTicket = (data) => postRequest("ticket", data);
  getTickets = (params = {}) => getRequest("ticket", params);
  getTicketDetails = (id1, id2) => getRequest(`ticket/${id1}/${id2}`);
  updateTicketDetails = (id, data) => putRequest(`ticket/${id}`, data);
  deleteTicket = (id) => deleteRequest(`ticket/${id}`);
  getFilteredTickets = (data) => postRequest("ticket/get_all_tickets", data);
}

// FOR ADMIN :  
class Login {
  postLogin = (data = {}) => postRequest("auth/login", data);
  postLoginRefresh = (data = {}) => postRequest("auth/refresh_token", data, false);
}

class ForgotPassword {
  putForgotPassword = (data = {}) => putRequest("user/password_reset", data);
  putPasswordChange = (data = {}) => putRequest("user/password_change", data);
}

class  AccessControl {
  getAccessControl = (params = {}) => postRequest("permission", params)
  getEnumsEntity = (params = {}) => getRequest("entity", params);
  updateAccessControl = (data) => putRequest("permission/update_permissions", data);
}

class Roles {
  getRoles = (params = {}) => getRequest("role", params);
  getRoleDetails = (id) => getRequest(`role/${id}`);
  createRole = (data) => postRequest("role", data);
  updateRoleDetails = (id, data) => putRequest(`role/${id}`, data);  
  deleteRole = (id) => deleteRequest(`role/${id}`);
}

class Organization {
  getOrgs = (params = {}) => getRequest("organization", params);
  getFilteredOrgs = (id) => getRequest(`organization/${id}`);
  getOrgDetails = (id) => getRequest(`organizations/${id}`);
  createOrg = (data) => postRequest("organization", data);
  updateOrgDetails = (id, data) => putRequest(`organization/${id}`, data);
  deleteOrg = (id) => deleteRequest(`organization/${id}`);
}

class Properties {
  getProperties = (params = {}) => postRequest("property/get_all_properties", params);
  getPropertyDetails = (id) => getRequest(`property/${id}`);
  createProperty = (data) => postRequest("property", data);
  updatePropertyDetails = (id, data) => putRequest(`property/${id}`, data);
  deleteProperty = (id) => deleteRequest(`property/soft/${id}`);
  hardDeleteProperty = (id) => deleteRequest(`property/${id}`);
  restoreProperty = (data) => postRequest("property/undo_property", data);
}

class Managers {
  getManagers = (params = {}) => getRequest("manager", params);
  getManagerDetails = (id) => getRequest(`manager/${id}`);
  createManager = (data) => postRequest("manager", data);
  updateManagerDetails = (id, data) => putRequest(`manager/${id}`, data);
  deleteManager = (id) => deleteRequest(`manager/${id}`);
}

class User {
  getUsers = (params = {}) => getRequest("user", params);
  getUserSelf = (params = {}) => getRequest("user/self", params);
  getFiltertedUser = (params = {}) => postRequest("user/get_all_user", params);
  getFiltertedUserByProperty = (params = {}) => postRequest("user/get_specific_property_users", params);
  getUserDetails = (id) => getRequest(`user/${id}`);
  createUser = (data) => postRequest("user", data);
  updateUserDetails = (id, data) => putRequest(`user/${id}`, data); 
  deleteUser = (id) => deleteRequest(`user/${id}`);
  getAllUserWithAdmin = (params = {}) => postRequest("user/get_shiftnote_all_user", params);
}

class Unit {
  getUnits = (params = {}) => getRequest("unit", params);
  getUnitDetails = (id) => getRequest(`unit/${id}`);
  createUnit = (data) => postRequest("unit", data);
  updateUnitDetails = (id, data) => putRequest(`unit/${id}`, data);
  deleteUnit = (id1, id2) => deleteRequest(`unit/soft/${id1}/${id2}`);
  hardDeleteUnit = (id1, id2) => deleteRequest(`unit/${id1}/${id2}`);
  restoreUnit = (data) => postRequest("unit/undo_unit", data);
}

class userUnit {
  getUserUnits = (params = {}) => getRequest("user_unit", params);
  getUserUnitDetails = (id) => getRequest(`user_unit/${id}`)
  createUserUnit = (data) => postRequest("user_unit", data);
  updateUserUnitDetails = (id, data) => putRequest(`user_unit/${id}`, data);
  deleteUserUnit = (data) => postRequest(`user_unit/soft/delete_user_unit`, data);
  restoreUserUnit = (data) => postRequest("user_unit/undo_user_unit", data);
  deleteUserUnitHard = (data) => postRequest("user_unit/delete_user_unit", data);
}

class userProperty {
  getUserProperties = (params = {}) => getRequest("user_property", params);
  getUserPropertyDetails = (id) => getRequest(`user_property/${id}`);
  createUserProperty = (data) => postRequest("user_property", data);
  updateUserPropertyDetails = (id, data) => putRequest(`user_property/${id}`, data);
  deleteUserProperty = (id) => postRequest(`user_property/soft/delete_user_property`, id);
  deleteUserPropertyHard = (id) => postRequest(`user_property/delete_user_property`, id);
  restoreUserProperty = (data) => postRequest("user_property/undo_user_property", data);
}

class Messages {
  createMessage = (data) => postRequest("ticket_message", data);
  getTicketStatus = (params = {}) => getRequest("ticket_status", params);
}


class MultiOrgProperty {
  getMultiOrgProperties = (params = {}) => getRequest("property/get_user_assign_properties", params);
  postMultiOrgUnits = (data) => postRequest("unit/org_property_units", data);
}

class Api {
  constructor() {
    // FOR ADMIN :  
    this.login = new Login();
    this.organization = new Organization();
    this.properties = new Properties();
    this.managers = new Managers();
    this.roles = new Roles();
    this.user = new User();
    this.unit = new Unit();
    this.userUnit = new userUnit();
    this.userProperty = new userProperty();
    this.getFiltertedUser = new getFiltertedUser();
    this.shiftNote = new ShiftNote();
    this.ticket = new Ticket();
    this.forgotPassword = new ForgotPassword();
    this.accessControl = new AccessControl();
    this.messages = new Messages();
    this.multiOrgProperty = new MultiOrgProperty();
    
    // FOR SUPER ADMIN :
    this.su_Organiation = new Su_Organiation();
    this.su_Property = new Su_Property();
    this.su_unit = new Su_Unit();
    this.assign_user_org = new Assign_user_org();
    this.assign_user_property = new Assign_user_porperty();
    this.Su_User = new Su_User();
    this.assign_user_unit = new Assign_user_unit();
  }
}

export const api = new Api();
